import { render, staticRenderFns } from "./Remedies.vue?vue&type=template&id=2c8f7c72"
import script from "./Remedies.vue?vue&type=script&lang=js"
export * from "./Remedies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports